import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state.socialMarketFoundations,
    (state) => state
)

export const selectSocialMarketFoundations = createSelector(
    baseSelector,
    (state) => state.partners
)

export const selectSocialMarketFoundationsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isFirstLoad
)

export const selectSocialMarketFoundationsLoading = createSelector(
    baseSelector,
    (state) => state.isLoading
)

export const selectSocialMarketFoundationsSearchQuery = createSelector(
    baseSelector,
    (state) => state.searchQuery
)